// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';

export default function LayoutBackgroundColor({color}: {color: string}) {
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: -1,
        width: '100%',
        height: '100%',
        backgroundColor: color,
      }}
    />
  );
}
